export const API_URL = {
    'populateSerialTransfer' : 'api/inventory/vas/transfer/serial/populate',
    'EXPLODE_BY_KEY_KITTING': 'api/inventory/vas/kitting/explodeByPackKey',
    'UCC_POPULATE': 'api/inventory/adjustment/ucc/populate',
    'PACK_MNGT_EDIT' : 'api/core/packmgmnttd',
    'SO_CUSTOMS_MSG': 'api/wave/customs/customsserviceorder',
    'RIGHTS': 'api/app/rights',
    'COMMON_DOCUMENT': 'api/inbound/document/'
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/models/api-urls.ts